import React, { useEffect, useState } from "react";
import { useSelector } from "react-redux";
import { ApplicationState } from '../../store'
import { format } from '../../helpers/number'
import { Button, Col, Divider, Input, Row, Typography, message, Select, Tooltip, Skeleton } from 'antd';
import { CopyOutlined } from '@ant-design/icons'
import ModalTerms from '../../components/Elements/ModalTerms'
import api from "../../helpers/api";
import { toast } from "react-toastify";
import { Link } from "react-router-dom";

const { Text } = Typography;

const AffiliateCommission = () => {

	const [messageApi, contextHolder] = message.useMessage();

	const userState = useSelector((state: ApplicationState) => state.user);
	const prefixState = useSelector((state: ApplicationState) => state.prefix)

	const [openTerms, setOpenTerms] = useState<boolean>(false)
	const handleModalTerms = () => setOpenTerms(!openTerms)

	const [fullUrl, setFullUrl] = useState<string>(userState.affiliate.link)
	const [isPage, setIsPage] = useState<string>('register')
	const [isRec, setIsRec] = useState<string>('')

	const [loadingBalance, setLoadingBalance] = useState<boolean>(false)

	const [dataAffiliateSummary, setDataAffiliateSummary] = useState<any>(null)

	const copyAffiliateLink = () => {
		navigator.clipboard.writeText(fullUrl);
		messageApi.open({
			type: 'success',
			content: 'คัดลอกลิงก์ชวนเพื่อนสำเร็จ',
		});
	};

	const handlePage = (value: any) => {
		setIsPage(value)
		const _urlFull = window.location.origin + '/' + value + '?ref=' + userState.affiliate.code
		const _urlRec = isRec && isRec !== 'friend' ? '&rec=' + isRec : ''
		const urlFull = _urlFull + _urlRec

		setFullUrl(urlFull)
	}

	const handleRec = (value: any) => {
		setIsRec(value)
		const _urlFull = window.location.origin + '/' + isPage + '?ref=' + userState.affiliate.code
		const _urlRec = value && value !== 'friend' ? '&rec=' + value : ''
		const urlFull = _urlFull + _urlRec

		setFullUrl(urlFull)
	}

	// const Aff_Credit = userState.info?.affiliate.balance;

	// // Mock data สำหรับ Table
	// const mockCommissionData = [
	// 	{
	// 		key: '1',
	// 		phoneNumber: '080-123-4567',
	// 		fullName: 'สมชาย ใจดี',
	// 		referralSource: 'Facebook',
	// 		registerDate: '15/11/2024 20:12',
	// 	},
	// 	{
	// 		key: '2',
	// 		phoneNumber: '081-987-6543',
	// 		fullName: 'สมหญิง รักดี',
	// 		referralSource: 'เพื่อนแนะนำ',
	// 		registerDate: '12/11/2024 20:12',
	// 	},
	// 	{
	// 		key: '3',
	// 		phoneNumber: '082-555-7777',
	// 		fullName: 'ประชา สุขใจ',
	// 		referralSource: 'Google',
	// 		registerDate: '10/11/2024 20:12',
	// 	},
	// 	{
	// 		key: '4',
	// 		phoneNumber: '083-111-2222',
	// 		fullName: 'วันดี มีสุข',
	// 		referralSource: 'Line',
	// 		registerDate: '08/11/2024 20:12',
	// 	},
	// 	{
	// 		key: '5',
	// 		phoneNumber: '084-888-9999',
	// 		fullName: 'กิตติ ชัยชนะ',
	// 		referralSource: 'Instagram',
	// 		registerDate: '05/11/2024 20:12',
	// 	},
	// ];

	// // Column definitions สำหรับ Table
	// const commissionColumns = [
	// 	{
	// 		title: 'สมาชิก',
	// 		key: 'member',
	// 		width: 200,
	// 		render: (record: any) => (
	// 			<div>
	// 				<div style={{ fontWeight: 'bold' }}>{record.phoneNumber}</div>
	// 				<div style={{ color: '#888', fontSize: '18px' }}>{record.fullName}</div>
	// 			</div>
	// 		),
	// 	},
	// 	{
	// 		title: 'รู้จักเราจาก',
	// 		key: 'additionalInfo',
	// 		width: 180,
	// 		render: (record: any) => (
	// 			<div>
	// 				<div>
	// 					<span>{record.referralSource}</span>
	// 				</div>
	// 				<div style={{ color: '#888', fontSize: '18px' }}>
	// 					<span>{record.registerDate}</span>
	// 				</div>
	// 			</div>
	// 		),
	// 	},
	// ];

	const callAffiliate = async () => {
		setLoadingBalance(true)
		try {
			const res = await api.get<void, any>('/member/affiliate/summary')
			setDataAffiliateSummary(res)
		} catch ({ message }: any) {
			toast.error(message as string)
		}
		setLoadingBalance(false)
	}

	const handleWithdraw = async (amount: number) => {
		try {
			const res = await api.post<void, any>('/member/affiliate/withdraw/new', {
				amount: amount
			})
			callAffiliate()
			toast.success(res.message as string)
		} catch ({ message }: any) {
			toast.error(message as string)
		}
	}

	useEffect(() => {
		callAffiliate()
	}, [])

	return (
		<>
			{contextHolder}
			<Row justify="center" className="margin-form-card">
				<Col xs={24} md={16} xl={12}>
					<div className="form-card2">
						<div className="form-card2-body">
							<div className="affiliate-commission">
								<div className="affiliate-commission__content">
									<div className="affiliate-commission__title">
										<span>ยอดที่ถอนได้</span>
										<span>
											<Tooltip placement="right" title={'อัพเดทยอด'} color='#121416'>
												<i className="fa-sharp fa-regular fa-arrows-rotate" style={{ fontSize: 18, marginLeft: 8 }} onClick={callAffiliate}></i>
											</Tooltip>
										</span>
									</div>
									{!loadingBalance && dataAffiliateSummary ? (
										<div className="affiliate-commission__amount">
											<span className="affiliate-commission__currency">฿</span>
											<span>{format(dataAffiliateSummary?.balance || 0)}</span>
										</div>
									) : (
										<Skeleton.Button active={true} shape={'default'} block={false} />
									)}
								</div>
								<div>
									<Button type="primary" block onClick={() => { handleWithdraw(dataAffiliateSummary?.balance || 0) }}>โยกเงิน</Button>
								</div>
							</div>

							<div className='rolling-text-extra'>
								<small>ยอดขั้นต่ำ <span className='rolling-text-extra-span'>฿{format(dataAffiliateSummary?.summary?.minWithdraw || 0, 0)}</span> ถึงจะสามารถกดรับเงินได้</small>
							</div>

							<div className='affiliate-text-info' style={{ marginTop: 12, background: 'linear-gradient(325deg, rgba(0, 0, 0, .7) 30%, rgba(0, 0, 0, 0) 100%)' }}>
								<div className="affiliate-text-top">
									<div className='affiliate-text-info-item'>
										<div>฿ {format(dataAffiliateSummary?.summary?.sumMonth || 0, 2)}</div>
										<div style={{ opacity: 0.8 }}><small>รายได้เดือนนี้</small></div>
									</div>
									<div className='affiliate-text-info-item'>
										<div>฿ {format(dataAffiliateSummary?.summary?.sumAll || 0, 2)}</div>
										<div style={{ opacity: 0.8 }}><small>รายได้ทั้งหมด</small></div>
									</div>
								</div>
								<div className="affiliate-text-bottom">
									<div className='affiliate-text-info-item'>
										<div>{format(dataAffiliateSummary?.summary?.memberAllTotal || 0, 0)} คน</div>
										<div style={{ opacity: 0.8 }}><small>เพื่อนทั้งหมด</small></div>
									</div>
									<div className='affiliate-text-info-item'>
										<div>{format(dataAffiliateSummary?.summary?.memberLv1Total || 0, 0)} คน</div>
										<div style={{ opacity: 0.8 }}><small>เพื่อนระดับ 1</small></div>
									</div>
									<div className='affiliate-text-info-item'>
										<div>{format(dataAffiliateSummary?.summary?.memberLv2Total || 0, 0)} คน</div>
										<div style={{ opacity: 0.8 }}><small>เพื่อนระดับ 2</small></div>
									</div>
								</div>
							</div>

							<Divider style={{ borderBlockStart: '1px solid rgba(255, 255, 255, 0.1)' }} />

							<div>
								<Text type="secondary" style={{ display: 'block', marginBottom: 8 }}>ลิงก์ชวนเพื่อน</Text>
								<Input.Group
									style={{ display: 'flex' }}
									compact
								>
									<Input
										value={fullUrl}
										style={{ background: '#0d0f10', color: '#fff' }}
										disabled
										size="small"
									/>
									<Button
										className="ant-btn-secondary"
										icon={<CopyOutlined style={{ fontSize: 18, marginTop: 1 }} />}
										style={{ height: 'auto' }}
										onClick={copyAffiliateLink}
									/>
								</Input.Group>

								<div className="affiliate-link">
									{prefixState?.info?.functions.homePage &&
										<Select
											defaultValue="register"
											optionFilterProp="children"
											onChange={(value) => handlePage(value)}
											size="small"
											style={{ width: '100%' }}
										>
											<Select.Option value="home" key="facebook">หน้าแรก</Select.Option>
											<Select.Option value="register" key="twitter">หน้าสมัคร</Select.Option>
										</Select>
									}

									<Select
										defaultValue="friend"
										optionFilterProp="children"
										onChange={(value) => handleRec(value)}
										size="small"
										style={{ width: '100%' }}
									>
										<Select.Option value="facebook" key="facebook">Facebook</Select.Option>
										<Select.Option value="twitter" key="twitter">Twitter</Select.Option>
										<Select.Option value="line" key="line">Line</Select.Option>
										<Select.Option value="google" key="google">Google</Select.Option>
										<Select.Option value="sms" key="sms">SMS</Select.Option>
										<Select.Option value="instargram" key="instargram">Instargram</Select.Option>
										<Select.Option value="youtube" key="youtube">Youtube</Select.Option>
										<Select.Option value="tiktok" key="tiktok">Tiktok</Select.Option>
										<Select.Option value="onlyfans" key="onlyfans">Onlyfans</Select.Option>
										<Select.Option value="telegram" key="telegram">Telegram</Select.Option>
										<Select.Option value="vk" key="vk">VK</Select.Option>
										<Select.Option value="friend" key="friend">เพื่อนแนะนำ</Select.Option>
										<Select.Option value="other" key="other">โฆษณาอื่น ๆ</Select.Option>
									</Select>
								</div>
							</div>

							{prefixState.info?.termandcondition?.affiliateDescription && (
								<div className="terms-and-conditions-button">
									<Button className="ant-btn-dark" onClick={handleModalTerms} style={{ height: 32 }}>
										<i className="fa-solid fa-circle-info" style={{ fontSize: 16 }}></i>
										<span>วิธีสร้างรายได้</span>
									</Button>
								</div>
							)}

							{userState.isPartner && (
								<Link to="/partner">
									<Button className="ant-btn-tertiary" block style={{ borderRadius: 12, marginTop: 12 }}>ระบบพันธมิตร</Button>
								</Link>
							)}
						</div>
					</div>

					{/* <div className="transaction-card" style={{ marginTop: 32, marginBottom: 32 }}>
						<div className="transaction-body">
							<div className='table-card' style={{ width: '100%', marginBottom: 24 }}>
								<Text style={{ marginBottom: 12, display: 'block' }}>รายการสมัครล่าสุด</Text>
								<Table
									dataSource={mockCommissionData}
									columns={commissionColumns}
									scroll={{ x: true }}
									pagination={{
										defaultPageSize: 5,
										pageSizeOptions: ['5', '10', '20'],
										total: mockCommissionData.length,
										current: 1,
										onChange: (page: number, pageSize: number) => {
											// console.log(page, pageSize)
										}
									}}
								/>
							</div>
						</div>
					</div> */}
				</Col>
			</Row>

			<ModalTerms isOpen={openTerms} onClose={() => setOpenTerms(false)} description={prefixState.info?.termandcondition?.affiliateDescription || ""} />
		</>
	);
};

export default AffiliateCommission;